export var GameTileType = /* @__PURE__ */ ((GameTileType2) => {
  GameTileType2["DEFAULT"] = "DEFAULT";
  GameTileType2["VIDEO"] = "VIDEO";
  GameTileType2["VIDEO_SMALL"] = "VIDEO_SMALL";
  GameTileType2["HIDDEN"] = "HIDDEN";
  return GameTileType2;
})(GameTileType || {});
export var GameType = /* @__PURE__ */ ((GameType2) => {
  GameType2["CASINO"] = "CASINO";
  GameType2["LIVE_CASINO"] = "LIVE_CASINO";
  GameType2["BINGO"] = "BINGO";
  GameType2["SLOTS"] = "SLOTS";
  return GameType2;
})(GameType || {});
export var GameSubtype = /* @__PURE__ */ ((GameSubtype2) => {
  GameSubtype2["LIVE"] = "LIVE";
  GameSubtype2["COLLECTOR"] = "COLLECTOR";
  return GameSubtype2;
})(GameSubtype || {});
